import React from 'react';

const CosmetologaIcon = () => (
  <svg className="w-6 h-6 inline-block mr-2 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"/>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M8 14s1.5 2 4 2 4-2 4-2" className="text-green-400"/>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 10h.01M15 10h.01" className="text-green-700"/>
  </svg>
);

const CosmiatraIcon = () => (
  <svg className="w-6 h-6 inline-block mr-2 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 16a4 4 0 100-8 4 4 0 000 8z" className="text-green-300"/>
  </svg>
);

const MatriculaIcon = () => (
  <svg className="w-6 h-6 inline-block mr-2 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"/>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 11v6m0-6l2 2m-2-2l-2 2" className="text-teal-400"/>
  </svg>
);

const MisionIcon = () => (
  <svg className="w-8 h-8 mb-2 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"/>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 12l3 3m0 0l-3 3m3-3H9m3-6l-3-3m0 0l3-3m-3 3h6" className="text-green-300"/>
  </svg>
);

const VisionIcon = () => (
  <svg className="w-8 h-8 mb-2 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M17 14l2 2m0 0l2 2m-2-2l-2 2m2-2l2-2" className="text-teal-300"/>
  </svg>
);

const ObjetivoIcon = () => (
  <svg className="w-8 h-8 mb-2 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 12l3 3m0 0l-3 3m3-3H9" className="text-emerald-300"/>
  </svg>
);

const FortalezasIcon = () => (
  <svg className="w-6 h-6 inline-block mr-2 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M5 3v4M3 5h4M5 21v-4M3 19h4m10-16v4m2-2h-4m4 14v-4m2 2h-4M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
  </svg>
);

const OportunidadesIcon = () => (
  <svg className="w-6 h-6 inline-block mr-2 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M13 10V3L4 14h7v7l9-11h-7z"/>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M17 8l2 2m0 0l2 2m-2-2l-2 2m2-2l2-2" className="text-teal-300"/>
  </svg>
);

const DebilidadesIcon = () => (
  <svg className="w-6 h-6 inline-block mr-2 text-rose-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M18.364 5.636l-12.728 12.728M5.636 5.636l12.728 12.728"/>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" className="text-rose-200"/>
  </svg>
);

const AmenazasIcon = () => (
  <svg className="w-6 h-6 inline-block mr-2 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M20.618 5.984A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016zM12 9v2m0 4h.01"/>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 14l1.5 1.5" className="text-orange-300"/>
  </svg>
);


// Fondo fijo con imagen optimizada y animaciones
const FixedBackground = () => (
  <div className="fixed inset-0 -z-10 overflow-hidden">
    {/* Contenedor de la imagen con URL corregida */}
    <div 
      className="absolute inset-0 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: "url('https://images.unsplash.com/photo-1544161515-4ab6ce6db874?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80')",
        backgroundAttachment: 'scroll'
      }}
    >
      {/* Overlay con gradiente para mejor legibilidad */}
      <div className="absolute inset-0 bg-gradient-to-b from-crema/90 via-crema/95 to-crema/20"></div>
    </div>
    
    {/* Elementos decorativos con animaciones */}
    <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-b from-green-50/20 to-transparent hidden md:block animate-pulse"></div>
    <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-gradient-to-t from-teal-50/20 to-transparent hidden md:block animate-pulse"></div>
    
    {/* Patrón geométrico animado */}
    <div className="absolute inset-0 opacity-3 md:opacity-5 mix-blend-overlay animate-spin-slow">
      <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
        <pattern 
          id="pattern" 
          x="0" 
          y="0" 
          width="60" 
          height="60" 
          patternUnits="userSpaceOnUse"
          patternTransform="rotate(15)"
        >
          <circle cx="30" cy="30" r="1" fill="#869370" opacity="0.4" />
          <circle cx="45" cy="45" r="0.8" fill="#6a7556" opacity="0.3" />
        </pattern>
        <rect x="0" y="0" width="100%" height="100%" fill="url(#pattern)" />
      </svg>
    </div>
    
    {/* Efecto de grano sutil para textura */}
    <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiPjxkZWZzPjxmaWx0ZXIgaWQ9Im5vaXNlIj48ZmVUdXJidWxlbmNlIHR5cGU9ImZyYWN0YWxOb2lzZSIgYmFzZUZyZXF1ZW5jeT0iMC43IiBudW1PY3RhdmVzPSIzIiBzdGl0Y2hUaWxlcz0ic3RpdGNoIi8+PC9maWx0ZXI+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbHRlcj0idXJsKCNub2lzZSkiIG9wYWNpdHk9IjAuMDIiLz48L3N2Zz4=')] 
      mix-blend-overlay pointer-events-none opacity-50 md:opacity-100"></div>
  </div>
);
function EsteticaHome({ setCurrentPage }) {
  return (
    <div className="relative">
      {/* Fondo fijo */}

     <div className="relative z-10">
      <FixedBackground />
      
      {/* Contenido scrolleable */}
    
        {/* Hero Section */}
        <section className="min-h-screen flex flex-col items-center justify-center relative overflow-hidden">
          {/* Contenido Hero */}
          <div className="container mx-auto px-4 sm:px-6 py-16 sm:py-32 text-center flex-grow flex flex-col justify-center relative z-10 min-h-screen">
            <p className="text-xs sm:text-sm uppercase tracking-[0.3em] text-green-700 font-medium mb-5 sm:mb-6 animate-fade-in-up">
              Cleo Estética · Caacupé
            </p>

            <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-semibold text-green-700 leading-[1.1] mb-6 sm:mb-8 animate-fade-in-up px-2">
              Terapia con piedras <span className="italic text-green-600">volcánicas</span>
            </h1>

            <div className="w-16 h-px bg-green-400 mx-auto mb-6 sm:mb-8 animate-fade-in-up delay-100"></div>

            <p className="text-lg sm:text-xl font-light text-gray-700 mb-4 max-w-2xl mx-auto animate-fade-in-up delay-100 px-4 leading-relaxed">
              Relajate con nuestro tratamiento exclusivo de piedras volcánicas, que alivian tensiones y revitalizan tu cuerpo.
            </p>

            <p className="text-xs sm:text-sm uppercase tracking-[0.2em] text-green-700/80 mb-8 sm:mb-10 animate-fade-in-up delay-100">
              Todos los tratamientos son unisex
            </p>

            {/* Botones */}
            <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4 animate-fade-in-up delay-150 px-6">
              <button
                onClick={() => setCurrentPage('faciales')}
                className="px-8 py-3.5 rounded-full bg-green-600 text-white font-medium tracking-wide hover:bg-green-700 shadow-md shadow-green-900/10 transition-colors duration-300"
              >
                Tratamientos faciales
              </button>

              <button
                onClick={() => setCurrentPage('corporales')}
                className="px-8 py-3.5 rounded-full bg-green-600 text-white font-medium tracking-wide hover:bg-green-700 shadow-md shadow-green-900/10 transition-colors duration-300"
              >
                Tratamientos corporales
              </button>

              <button
                onClick={() => setCurrentPage('masajes')}
                className="px-8 py-3.5 rounded-full bg-green-600 text-white font-medium tracking-wide hover:bg-green-700 shadow-md shadow-green-900/10 transition-colors duration-300"
              >
                Masajes
              </button>
            </div>

            {/* Indicador scroll */}
            <div className="mt-16 sm:mt-24">
              <div className="inline-flex flex-col items-center text-green-700/70">
                <p className="text-[11px] uppercase tracking-[0.25em] mb-3">Descubrí más</p>
                <span className="block w-px h-10 bg-gradient-to-b from-green-600/60 to-transparent"></span>
              </div>
            </div>
          </div>
        </section>

    <section className="w-full py-12 sm:py-16 md:py-24 px-4 relative">
  <div className="container mx-auto max-w-6xl relative">
    {/* Encabezado */}
    <div className="text-center mb-12 sm:mb-16">
      <p className="text-xs uppercase tracking-[0.3em] text-green-700 font-medium mb-3">Quiénes somos</p>
      <h2 className="text-4xl sm:text-5xl md:text-6xl font-semibold text-green-700 mb-4 font-serif px-2">
        Cleo Estética
      </h2>
      <div className="w-16 h-px bg-green-400 mx-auto mb-5"></div>
      <p className="text-lg sm:text-xl text-gray-600 max-w-2xl mx-auto font-light italic px-4">
        "Donde la belleza se encuentra con la excelencia profesional"
      </p>
    </div>
    
    {/* Contenido principal */}
    <div className="flex flex-col lg:flex-row gap-8 sm:gap-12 items-center">
      {/* Tarjeta de presentación */}
      <div className="w-full lg:w-1/2">
        <div className="bg-white/20 backdrop-blur-sm rounded-2xl sm:rounded-3xl shadow-lg p-6 sm:p-8 md:p-10 border border-white/30 transition-shadow duration-500 hover:shadow-xl animate-fade-in-up">
                      <div className="flex flex-col sm:flex-row items-center sm:items-start mb-6 animate-fade-in-up delay-100">
              <div className="w-20 h-20 sm:w-16 sm:h-16 rounded-full overflow-hidden border-4 border-green-100 shadow-md mb-4 sm:mb-0 sm:mr-4 ">
                <img 
                  src="https://i.imgur.com/u6Qbkej.jpeg" 
                  alt="Pamela - Dueña de Cleo Estética" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="text-center sm:text-left">
                <h3 className="text-xl sm:text-2xl font-semibold text-gray-900 font-serif animate-fade-in-up delay-200">Pamela Ruiz Diaz</h3> 
                <p className="text-green-600 text-sm sm:text-base font-semibold animate-fade-in-up delay-300">Fundadora & Especialista en Drenaje Linfático Brasilero</p>
              </div>
            </div>
          
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 italic font-light animate-fade-in-up delay-400">
            "En Cleo Estética creemos que cada persona y cada piel son únicas. Por eso, cada tratamiento es cuidadosamente personalizado, teniendo en cuenta tus necesidades y objetivos."
          </p>
          
          <div className="border-l-4 border-green-400 pl-4 mb-6 animate-fade-in-up delay-500 space-y-2">
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              Con más de 6 años de experiencia en el área de la estética, seguimos perfeccionando nuestras técnicas y conocimientos para ofrecer tratamientos que combinan profesionalismo, dedicación y resultados visibles.
            </p>
            <p className="text-base sm:text-lg font-medium text-green-800">
              Porque para nosotros, la estética no se trata solo de un cambio exterior, sino de que puedas sentirte bien con vos misma. 💚
            </p>
          </div>
          
          <div className="space-y-4 sm:space-y-5 mb-6 sm:mb-8">
            <div className="flex flex-col sm:flex-row items-start bg-green-50/60 backdrop-blur-sm rounded-xl p-4 border border-green-200/40 animate-fade-in-up delay-600 transition-colors duration-300">
              <div className="bg-green-100/80 p-3 rounded-lg mb-3 sm:mb-0 sm:mr-4 self-center sm:self-start">
                <CosmetologaIcon />
              </div>
              <div className="text-center sm:text-left">
                <h4 className="font-semibold text-gray-900 font-serif text-sm sm:text-base">Cosmetóloga y Cosmiatra Certificada</h4>
                <p className="text-gray-600 text-sm">Especialización en Dermatocosmiatría y Estética Facial y Corporal</p>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row items-start bg-teal-50/60 backdrop-blur-sm rounded-xl p-4 border border-teal-200/40 animate-fade-in-up delay-700 transition-colors duration-300">
              <div className="bg-teal-100/80 p-3 rounded-lg mb-3 sm:mb-0 sm:mr-4 self-center sm:self-start">
                <CosmiatraIcon />
              </div>
              <div className="text-center sm:text-left">
                <h4 className="font-semibold text-gray-900 font-serif text-sm sm:text-base">Especialista en Drenaje Linfático Brasilero</h4>
                <p className="text-gray-600 text-sm">Técnica avanzada de moldeo, desintoxicación y reducción corporal de alta precisión</p>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row items-start bg-emerald-50/60 backdrop-blur-sm rounded-xl p-4 border border-emerald-200/40 animate-fade-in-up delay-800 transition-colors duration-300">
              <div className="bg-emerald-100/80 p-3 rounded-lg mb-3 sm:mb-0 sm:mr-4 self-center sm:self-start">
                <MatriculaIcon />
              </div>
              <div className="text-center sm:text-left">
                <h4 className="font-semibold text-gray-900 font-serif text-sm sm:text-base">Acreditaciones Profesionales</h4>
                <p className="text-gray-600 text-sm font-medium">Matrícula Profesional N° =18-20220408-01</p>
              </div>
            </div>

            {/* Texto destacado debajo de la matrícula */}
            <div className="bg-gradient-to-r from-green-100/80 to-teal-100/80 rounded-xl p-5 border border-green-200 text-center sm:text-left shadow-sm">
              <h4 className="font-serif font-bold text-green-900 text-base mb-1">
                Más que un tratamiento, un momento para vos.
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed">
                En Cleo Estética cuidamos cada detalle para que tu visita sea un momento de conexión, dedicación y renovación. Un espacio pensado para desconectarte de la rutina y volver a vos.
              </p>
            </div>
          </div>
          
          <p className="text-base sm:text-lg text-green-900 leading-relaxed italic font-medium animate-fade-in-up delay-900 text-center sm:text-left">
            "En Cleo Estética no solo cuidamos tu piel, creamos un espacio donde el bienestar, la belleza y el cuidado se encuentran para que te sientas bien por dentro y por fuera. 💚"
          </p>
          
          {/* Botones de redes sociales */}
          <div className="flex justify-center space-x-4 mt-8 animate-fade-in-up delay-1000">
            <a href="https://facebook.com/Cleo.estetica20/" target="_blank" rel="noopener noreferrer" className="bg-blue-600 text-white p-3 rounded-full hover:bg-blue-700 transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"/>
              </svg>
            </a>
            <a href="https://instagram.com/cleo_estetica20/" target="_blank" rel="noopener noreferrer" className="bg-pink-600 text-white p-3 rounded-full hover:bg-pink-700 transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
              </svg>
            </a>
            <a href="https://wa.me/+595986523658" target="_blank" rel="noopener noreferrer" className="bg-green-500 text-white p-3 rounded-full hover:bg-green-600 transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.515 5.392 1.521 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
      
      {/* Galería de imágenes */}
      <div className="w-full lg:w-1/2">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          {/* Imágenes iniciales */}
          <div className="relative rounded-xl sm:rounded-2xl overflow-hidden shadow-lg transform transition-all duration-500 hover:scale-105 group animate-fade-in-up delay-200">
            <img 
              src="https://i.imgur.com/JtyuXQm.jpeg" 
              alt="Tratamiento Facial Personalizado" 
              className="w-full h-48 sm:h-72 object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-4 sm:p-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <h4 className="text-white text-lg sm:text-xl font-serif">Terapia Facial</h4>
            </div>
          </div>
          
          <div className="relative rounded-xl sm:rounded-2xl overflow-hidden shadow-lg transform transition-all duration-500 hover:scale-105 group mt-0 sm:mt-10 animate-fade-in-up delay-300">
            <img 
              src="https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=80" 
              alt="Ambiente de Lujo" 
              className="w-full h-48 sm:h-72 object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-4 sm:p-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <h4 className="text-white text-lg sm:text-xl font-serif">Espacio de Relajación</h4>
            </div>
          </div>
          
          <div className="relative rounded-xl sm:rounded-2xl overflow-hidden shadow-lg transform transition-all duration-500 hover:scale-105 group animate-fade-in-up delay-400">
            <img 
              src="https://img.freepik.com/foto-gratis/hermosa-joven-encuentra-mesa-esteticista-recibe-procedimientos_343596-4240.jpg?semt=ais_hybrid&w=740" 
              alt="Tecnología Avanzada" 
              className="w-full h-48 sm:h-72 object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-4 sm:p-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <h4 className="text-white text-lg sm:text-xl font-serif">Tecnología de Vanguardia</h4>
            </div>
          </div>
          
          <div className="relative rounded-xl sm:rounded-2xl overflow-hidden shadow-lg transform transition-all duration-500 hover:scale-105 group mt-0 sm:mt-10 animate-fade-in-up delay-500">
            <img 
              src="https://www.unit.br/hs-fs/hubfs/a-web-mkt/_inbound-mkt/blog-unificado/2024/_imagens/medico-de-cosmetologia-e-paciente.jpg?width=1380&height=920&name=medico-de-cosmetologia-e-paciente.jpg" 
              alt="Productos Exclusivos" 
              className="w-full h-48 sm:h-72 object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-4 sm:p-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <h4 className="text-white text-lg sm:text-xl font-serif">Productos de Primera Línea</h4>
            </div>
          </div>
        </div>
        
                      {/* Botón Ver más resultados - Versión mejorada */}
        <div className="text-center mt-8 sm:mt-10 relative">
          <button 
            className="bg-gradient-to-r from-green-500 to-teal-600 text-white px-6 sm:px-8 py-2.5 sm:py-3 rounded-full font-medium hover:from-green-600 hover:to-teal-700 transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center mx-auto group text-sm sm:text-base"
            onClick={(e) => {
              const gallery = document.getElementById('masResultados');
              const button = e.currentTarget;
              const icon = button.querySelector('.button-icon');
              
              if (gallery.classList.contains('hidden')) {
                gallery.classList.remove('hidden');
                button.innerHTML = 'Mostrar menos <span class="button-icon ml-2 transition-transform duration-300 group-hover:translate-y-0.5"><svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 sm:h-5 sm:w-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clip-rule="evenodd" /></svg></span>';
              } else {
                gallery.classList.add('hidden');
                button.innerHTML = 'Ver más resultados <span class="button-icon ml-2 transition-transform duration-300 group-hover:translate-y-0.5"><svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 sm:h-5 sm:w-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" /></svg></span>';
              }
              
              // Scroll suave a la galería cuando se muestra
              if (!gallery.classList.contains('hidden')) {
                gallery.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
              }
            }}
          >
            Ver más resultados
            <span className="button-icon ml-2 transition-transform duration-300 group-hover:translate-y-0.5">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 sm:h-5 sm:w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </span>
          </button>
          
          {/* Efecto de onda al hacer clic */}
          <span className="absolute inset-0 flex justify-center items-center pointer-events-none">
            <span className="animate-ping absolute inline-flex h-12 w-12 sm:h-16 sm:w-16 rounded-full bg-teal-400 opacity-0 group-hover:opacity-30 transition-opacity duration-300"></span>
          </span>
        </div>
        
        {/* Galería expandida (oculta inicialmente) */}
        <div className="hidden mt-6 sm:mt-8 grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4" id="masResultados">
          {/* Imágenes adicionales con URLs corregidas */}
          <div className="relative rounded-lg sm:rounded-xl overflow-hidden shadow-md h-40 sm:h-48 group">
            <img 
              src="https://i.imgur.com/6w7iNqp.jpeg" 
              alt="Resultado 1" 
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-3 sm:p-4 opacity-0 group-hover:opacity-100 transition-opacity">
              <span className="text-white font-medium text-sm sm:text-base">Antes</span>
            </div>
          </div>
          
          <div className="relative rounded-lg sm:rounded-xl overflow-hidden shadow-md h-40 sm:h-48 group">
            <img 
              src="https://i.imgur.com/V5anFvg.jpeg" 
              alt="Resultado 2" 
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-3 sm:p-4 opacity-0 group-hover:opacity-100 transition-opacity">
              <span className="text-white font-medium text-sm sm:text-base">Despues</span>
            </div>
          </div>
          
          <div className="relative rounded-lg sm:rounded-xl overflow-hidden shadow-md h-40 sm:h-48 group">
            <img 
              src="https://i.imgur.com/G8FnJ4d.jpeg" 
              alt="Resultado 3" 
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-3 sm:p-4 opacity-0 group-hover:opacity-100 transition-opacity">
              <span className="text-white font-medium text-sm sm:text-base">Antes</span>
            </div>
          </div>
          
          <div className="relative rounded-lg sm:rounded-xl overflow-hidden shadow-md h-40 sm:h-48 group">
            <img 
              src="https://i.imgur.com/TtTdbMh.jpeg" 
              alt="Resultado 4" 
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-3 sm:p-4 opacity-0 group-hover:opacity-100 transition-opacity">
              <span className="text-white font-medium text-sm sm:text-base">Despues</span>
            </div>
          </div>
          
          <div className="relative rounded-lg sm:rounded-xl overflow-hidden shadow-md h-40 sm:h-48 group">
            <img 
              src="https://i.imgur.com/WZuSSPz.jpeg" 
              alt="Resultado 5" 
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-3 sm:p-4 opacity-0 group-hover:opacity-100 transition-opacity">
              <span className="text-white font-medium text-sm sm:text-base">Antes</span>
            </div>
          </div>
          
          <div className="relative rounded-lg sm:rounded-xl overflow-hidden shadow-md h-40 sm:h-48 group">
            <img 
              src="https://i.imgur.com/YB0UfgP.jpeg" 
              alt="Resultado 6" 
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-3 sm:p-4 opacity-0 group-hover:opacity-100 transition-opacity">
              <span className="text-white font-medium text-sm sm:text-base">Despues</span>
            </div>
          </div>

          <div className="relative rounded-lg sm:rounded-xl overflow-hidden shadow-md h-40 sm:h-48 group">
            <img
              src="/images/resultado-7-antes.webp"
              alt="Resultado 7"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-3 sm:p-4 opacity-0 group-hover:opacity-100 transition-opacity">
              <span className="text-white font-medium text-sm sm:text-base">Antes</span>
            </div>
          </div>

          <div className="relative rounded-lg sm:rounded-xl overflow-hidden shadow-md h-40 sm:h-48 group">
            <img
              src="/images/resultado-7-despues.webp"
              alt="Resultado 8"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-3 sm:p-4 opacity-0 group-hover:opacity-100 transition-opacity">
              <span className="text-white font-medium text-sm sm:text-base">Despues</span>
            </div>
          </div>

          <div className="relative rounded-lg sm:rounded-xl overflow-hidden shadow-md h-40 sm:h-48 group">
            <img
              src="/images/resultado-8-antes.webp"
              alt="Resultado 9"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-3 sm:p-4 opacity-0 group-hover:opacity-100 transition-opacity">
              <span className="text-white font-medium text-sm sm:text-base">Antes</span>
            </div>
          </div>

          <div className="relative rounded-lg sm:rounded-xl overflow-hidden shadow-md h-40 sm:h-48 group">
            <img
              src="/images/resultado-8-despues.webp"
              alt="Resultado 10"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-3 sm:p-4 opacity-0 group-hover:opacity-100 transition-opacity">
              <span className="text-white font-medium text-sm sm:text-base">Despues</span>
            </div>
          </div>

          <div className="relative rounded-lg sm:rounded-xl overflow-hidden shadow-md h-40 sm:h-48 group">
            <img
              src="/images/resultado-9-antes.webp"
              alt="Resultado 11"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-3 sm:p-4 opacity-0 group-hover:opacity-100 transition-opacity">
              <span className="text-white font-medium text-sm sm:text-base">Antes</span>
            </div>
          </div>

          <div className="relative rounded-lg sm:rounded-xl overflow-hidden shadow-md h-40 sm:h-48 group">
            <img
              src="/images/resultado-9-despues.webp"
              alt="Resultado 12"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-3 sm:p-4 opacity-0 group-hover:opacity-100 transition-opacity">
              <span className="text-white font-medium text-sm sm:text-base">Despues</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
        

        {/* Sección de Misión, Visión, Objetivos */}
        <section className="w-full py-12 sm:py-16 md:py-24 px-4 relative">
          <div className="container mx-auto max-w-6xl relative">
            {/* Encabezado */}
            <div className="text-center mb-12 sm:mb-16 md:mb-20">
              <p className="text-xs uppercase tracking-[0.3em] text-green-700 font-medium mb-3">Lo que nos guía</p>
              <h2 className="text-4xl sm:text-5xl md:text-6xl font-semibold text-green-700 mb-4 font-serif px-2">
                Nuestra esencia
              </h2>
              <div className="w-16 h-px bg-green-400 mx-auto mb-5"></div>
              <p className="text-lg sm:text-xl text-gray-600 max-w-2xl mx-auto font-light italic px-4">
                "Los principios que definen nuestra excelencia y compromiso"
              </p>
            </div>
            
            {/* Misión y Visión */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 md:gap-10 mb-12 sm:mb-16">
              {/* Tarjeta Misión */}
              <div className="bg-white/20 backdrop-blur-sm rounded-2xl sm:rounded-3xl shadow-lg p-6 sm:p-8 md:p-10 border border-white/30 transform transition-all duration-500 hover:shadow-xl animate-fade-in-up delay-200">
                <div className="flex flex-col items-center text-center mb-6 sm:mb-8">
                  <div className="bg-gradient-to-br from-green-100/80 to-green-200/80 p-4 sm:p-5 rounded-full mb-4 sm:mb-6 ">
                    <MisionIcon />
                  </div>
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900 font-serif">Misión</h3>
                  <div className="w-16 sm:w-20 h-1 bg-gradient-to-r from-green-400 to-teal-500 my-3 sm:my-4"></div>
                </div>
                <p className="text-gray-700 leading-relaxed text-center font-light text-sm sm:text-base">
                  "En Cleo Estética, nos dedicamos a ofrecer experiencias de belleza transformadoras mediante tratamientos personalizados que combinan tecnología de vanguardia, productos de élite y un enfoque holístico del bienestar. Nuestro propósito es realzar la belleza auténtica de cada persona mientras cultivamos su confianza y autoestima."
                </p>
              </div>
              
              {/* Tarjeta Visión */}
              <div className="bg-white/20 backdrop-blur-sm rounded-2xl sm:rounded-3xl shadow-lg p-6 sm:p-8 md:p-10 border border-white/30 transform transition-all duration-500 hover:shadow-xl animate-fade-in-up delay-300">
                <div className="flex flex-col items-center text-center mb-6 sm:mb-8">
                  <div className="bg-gradient-to-br from-teal-100/80 to-teal-200/80 p-4 sm:p-5 rounded-full mb-4 sm:mb-6 ">
                    <VisionIcon />
                  </div>
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900 font-serif">Visión</h3>
                  <div className="w-16 sm:w-20 h-1 bg-gradient-to-r from-teal-400 to-emerald-500 my-3 sm:my-4"></div>
                </div>
                <p className="text-gray-700 leading-relaxed text-center font-light text-sm sm:text-base space-y-2">
                  <span>Seguir creciendo como un espacio de referencia en estética facial y corporal, destacándonos por la atención personalizada, la actualización constante y el compromiso con cada persona que confía en Cleo.</span>
                  <br /><br />
                  <span className="font-medium text-emerald-800">Buscamos crear una experiencia cercana y profesional, donde la innovación, el bienestar y el cuidado se encuentren para acompañar a cada cliente en su proceso de sentirse y verse mejor. 💚</span>
                </p>
              </div>
            </div>

            {/* Compromisos y Objetivos */}
            <div className="bg-white/20 backdrop-blur-sm rounded-2xl sm:rounded-3xl shadow-lg p-6 sm:p-8 md:p-12 border border-white/30 relative overflow-hidden animate-fade-in-up delay-400">
              <div className="flex flex-col items-center text-center mb-8 sm:mb-12 relative z-10">
                <div className="bg-gradient-to-br from-emerald-100/80 to-emerald-200/80 p-4 sm:p-5 rounded-full mb-4 sm:mb-6 ">
                  <ObjetivoIcon />
                </div>
                <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 font-serif">Nuestros Compromisos</h3>
                <div className="w-20 sm:w-24 h-1 bg-gradient-to-r from-emerald-400 to-teal-500 my-3 sm:my-4"></div>
              </div>
              
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 relative z-10">
                {/* Compromisos */}
                <div className="bg-gradient-to-b from-green-50/50 to-white/50 backdrop-blur-sm rounded-xl sm:rounded-2xl p-6 sm:p-8 shadow-inner border border-green-200/50 animate-fade-in-up delay-500 transition-shadow duration-300 hover:shadow-md">
                  <h4 className="text-lg sm:text-xl font-semibold text-gray-900 mb-4 sm:mb-6 pb-2 sm:pb-3 border-b border-green-200 font-serif flex items-center">
                    <svg className="w-5 h-5 sm:w-6 sm:h-6 text-green-500 mr-2 sm:mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"></path>
                    </svg>
                    Nuestros Compromisos
                  </h4>
                  <ul className="space-y-3 sm:space-y-4">
                    <li className="flex items-start">
                      <div className="bg-green-100 p-1.5 sm:p-2 rounded-full mr-3 sm:mr-4 flex-shrink-0 mt-1">
                        <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                        </svg>
                      </div>
                      <div>
                        <strong className="text-gray-900 block text-sm font-semibold">Actualización constante</strong>
                        <span className="text-gray-700 font-light text-xs sm:text-sm">Seguir formándonos y perfeccionando nuestras técnicas para ofrecer tratamientos actuales y personalizados.</span>
                      </div>
                    </li>
                    <li className="flex items-start">
                      <div className="bg-green-100 p-1.5 sm:p-2 rounded-full mr-3 sm:mr-4 flex-shrink-0 mt-1">
                        <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                        </svg>
                      </div>
                      <div>
                        <strong className="text-gray-900 block text-sm font-semibold">Atención personalizada</strong>
                        <span className="text-gray-700 font-light text-xs sm:text-sm">Conocer las necesidades de cada persona y adaptar cada tratamiento a sus objetivos y características.</span>
                      </div>
                    </li>
                    <li className="flex items-start">
                      <div className="bg-green-100 p-1.5 sm:p-2 rounded-full mr-3 sm:mr-4 flex-shrink-0 mt-1">
                        <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                        </svg>
                      </div>
                      <div>
                        <strong className="text-gray-900 block text-sm font-semibold">Calidad y profesionalismo</strong>
                        <span className="text-gray-700 font-light text-xs sm:text-sm">Trabajar con responsabilidad, dedicación y productos seleccionados para brindar una experiencia segura y profesional.</span>
                      </div>
                    </li>
                    <li className="flex items-start">
                      <div className="bg-green-100 p-1.5 sm:p-2 rounded-full mr-3 sm:mr-4 flex-shrink-0 mt-1">
                        <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                        </svg>
                      </div>
                      <div>
                        <strong className="text-gray-900 block text-sm font-semibold">Innovación</strong>
                        <span className="text-gray-700 font-light text-xs sm:text-sm">Incorporar nuevas técnicas y herramientas que aporten valor a nuestros tratamientos faciales y corporales.</span>
                      </div>
                    </li>
                    <li className="flex items-start">
                      <div className="bg-green-100 p-1.5 sm:p-2 rounded-full mr-3 sm:mr-4 flex-shrink-0 mt-1">
                        <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                        </svg>
                      </div>
                      <div>
                        <strong className="text-gray-900 block text-sm font-semibold">Confianza</strong>
                        <span className="text-gray-700 font-light text-xs sm:text-sm">Construir relaciones duraderas con quienes eligen Cleo, basadas en la cercanía, el respeto y la honestidad.</span>
                      </div>
                    </li>
                  </ul>
                </div>
                
                {/* Objetivos Clave */}
                <div className="bg-gradient-to-b from-teal-50/50 to-white/50 backdrop-blur-sm rounded-xl sm:rounded-2xl p-6 sm:p-8 shadow-inner border border-teal-200/50 animate-fade-in-up delay-600 transition-shadow duration-300 hover:shadow-md">
                  <h4 className="text-lg sm:text-xl font-semibold text-gray-900 mb-4 sm:mb-6 pb-2 sm:pb-3 border-b border-teal-200 font-serif flex items-center">
                    <svg className="w-5 h-5 sm:w-6 sm:h-6 text-teal-500 mr-2 sm:mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
                    </svg>
                    Objetivos Clave
                  </h4>
                  <ul className="space-y-3 sm:space-y-4">
                    <li className="flex items-start">
                      <span className="text-lg mr-3">✨</span>
                      <div>
                        <strong className="text-gray-900 block text-sm font-semibold">Resultados que se sostienen</strong>
                        <span className="text-gray-700 font-light text-xs sm:text-sm">Acompañar cada tratamiento con un seguimiento que permita ver los cambios y mantenerlos en el tiempo.</span>
                      </div>
                    </li>
                    <li className="flex items-start">
                      <span className="text-lg mr-3">✨</span>
                      <div>
                        <strong className="text-gray-900 block text-sm font-semibold">Promover el autocuidado</strong>
                        <span className="text-gray-700 font-light text-xs sm:text-sm">Compartir recomendaciones y hábitos simples para que cada persona cuide su piel y su cuerpo también en casa.</span>
                      </div>
                    </li>
                    <li className="flex items-start">
                      <span className="text-lg mr-3">✨</span>
                      <div>
                        <strong className="text-gray-900 block text-sm font-semibold">Acompañar cada momento</strong>
                        <span className="text-gray-700 font-light text-xs sm:text-sm">Ofrecer propuestas pensadas para cada etapa, desde un evento especial hasta el cambio de estación.</span>
                      </div>
                    </li>
                    <li className="flex items-start">
                      <span className="text-lg mr-3">✨</span>
                      <div>
                        <strong className="text-gray-900 block text-sm font-semibold">Llegar a más personas</strong>
                        <span className="text-gray-700 font-light text-xs sm:text-sm">Acercar nuestros tratamientos a más gente sin perder la dedicación que ponemos en cada sesión.</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              
              {/* Cita final */}
              <div className="mt-12 sm:mt-16 text-center relative z-10">
                <p className="text-lg sm:text-xl italic font-semibold text-green-800 max-w-3xl mx-auto px-4">
                  "Cleo evoluciona con vos: nuevos conocimientos, nuevas técnicas y nuevas formas de acompañarte. 💚"
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default EsteticaHome;